import { useParams } from 'react-router-dom'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { useTabNavigate } from 'hooks/useTabNavigate'

import { SubscriptionTab } from './SubscriptionSlug'

export const SubscriptionNavigation = (): JSX.Element => {
  const tabNavigate = useTabNavigate()
  const params = useParams<{
    id: string
    slug: string
  }>()

  return (
    <div>
      <Tabs value={params.slug} onValueChange={tabNavigate} className='mt-2'>
        <TabsList>
          <TabsTrigger value={SubscriptionTab.MAIN}>Main</TabsTrigger>

          <TabsTrigger value={SubscriptionTab.DETAILS}>Details</TabsTrigger>

          <TabsTrigger value={SubscriptionTab.PLATFORMS}>Platforms</TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  )
}
